import React, { useCallback } from 'react';
import Flex from 'ui/Flex/Flex';
import { ModuleT } from 'business/constants';
import ModuleCheckbox from './ModuleCheckbox';
import {
    ExtraFeatureT,
    EXTRA_FEATURES,
    MODULES,
    ModuleDetailsT,
} from './helpers/definitions';
import { ModuleObjectT } from './helpers/types';

const ExtraFeatures = ({
    moduleExtraFeatures,
    extraFeatures,
    setExtraFeatures,
}: {
    moduleExtraFeatures: Partial<Record<ExtraFeatureT, ModuleDetailsT>>;
    extraFeatures: ExtraFeatureT[];
    setExtraFeatures: (extraFeatures: ExtraFeatureT[]) => void;
}) => {
    const checkboxes = Object.keys(moduleExtraFeatures).map(
        (extraFeatureName) => {
            const extraFeatureDetails = moduleExtraFeatures[extraFeatureName];
            if (!extraFeatureDetails) {
                return <></>;
            }
            const extraFeature: ModuleObjectT = {
                ...extraFeatureDetails,
                value: extraFeatureName,
            };
            return (
                <Flex key={extraFeature.value} sx={{ m: 1 }}>
                    <ModuleCheckbox
                        module={extraFeature}
                        checked={extraFeatures.includes(extraFeature.value)}
                        modules={extraFeatures}
                        setModules={setExtraFeatures}
                    />
                </Flex>
            );
        },
    );
    return <>{checkboxes}</>;
};

type ModuleFormProps = {
    modules: ModuleT[];
    setModules: (modules: ModuleT[]) => void;
    extraFeatures: ExtraFeatureT[];
    setExtraFeatures: (extraFeatures: ExtraFeatureT[]) => void;
};

const ModuleForm = ({
    modules,
    setModules,
    extraFeatures,
    setExtraFeatures,
}: ModuleFormProps) => {
    const moduleCheckboxes = useCallback(
        () =>
            Object.keys(MODULES).map((moduleName) => {
                const module = {
                    ...MODULES[moduleName],
                    value: moduleName,
                };
                const moduleExtraFeatures = EXTRA_FEATURES[moduleName];
                return (
                    <ModuleCheckbox
                        key={moduleName}
                        module={module}
                        checked={modules.includes(moduleName)}
                        modules={modules}
                        setModules={setModules}
                    >
                        <Flex
                            flexDirection="column"
                            overflow="scroll"
                            maxHeight="20vh"
                        >
                            <ExtraFeatures
                                moduleExtraFeatures={moduleExtraFeatures}
                                extraFeatures={extraFeatures}
                                setExtraFeatures={setExtraFeatures}
                            />
                        </Flex>
                    </ModuleCheckbox>
                );
            }),
        [modules, extraFeatures],
    );

    return (
        <Flex justifyContent="space-between" margin="10px">
            {moduleCheckboxes()}
        </Flex>
    );
};

export default React.memo(ModuleForm);
